import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByOid',
  pure: true 
})
export class FilterByIdPipe implements PipeTransform {

  transform(items: any[], oid: number): any {
    return items.filter(item => item.Oid == oid);  
  }
}